import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import LoaderWithBackDrop from '../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp';
import { COS_PREVIEW_PATH } from '../../../utils/cpci.util';

/**
 * Solutions > COS Children Assessment > Preview.
 *
 * Just a redirect to the question-by-question preview of the COS catalogue.
 * Preview is read-only: it never builds an assessment, so it costs no
 * credits/tokens and works even when the workspace balance is empty.
 * history.replace (not push) keeps this step out of the back-button stack.
 */
const SolutionChildrenAssessmentPreviewPage = () => {
    const history = useHistory();

    useEffect(() => {
        history.replace(COS_PREVIEW_PATH);
    }, [history]);

    return <LoaderWithBackDrop loading />;
};

export default SolutionChildrenAssessmentPreviewPage;
